import { Spin } from "antd";
import TreeList, { Column, Scrolling } from "devextreme-react/tree-list";
import { documentStatus } from "../../../../constants";
import { useSearchParams } from "../../../../hook/use-search-params";
import { useDocumentContent } from "../../hooks/document-content/use-document-content";

export const EditorMenu = () => {
  const { searchParams } = useSearchParams();
  const isPublishStatus = searchParams.get("status") === documentStatus.publish.value;
  const action = searchParams.get("action");
  const viewMode = searchParams.get("viewMode") || (isPublishStatus || action === "process" ? "preview" : "edit");

  const { contentTitle, isLoading } = useDocumentContent();

  const handleClickScroll = (e: React.MouseEvent<HTMLAnchorElement>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "auto", block: "center", inline: "center" });
    }
  };

  const titleRender = (cellInfo: { data: { Id: number; Title: string; Content: string } }) => {
    const id = `title-${cellInfo.data.Id}`;
    return (
      <div className="document-editor__menu-item" style={{ position: "relative" }}>
        <a
          href="a"
          style={{
            textDecoration: "none",
            display: "-webkit-box",
            WebkitLineClamp: 1,
            WebkitBoxOrient: "vertical",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: "inherit",
            paddingLeft: 0,
            fontWeight: "400",
            fontSize: "12px",
            opacity: 0,
          }}
          dangerouslySetInnerHTML={{
            __html: cellInfo.data.Content.replace(
              /(.*)(">)([^<>]*)(<\/span><\/strong><\/p><\/div>)/,
              (_, before, quoteEnd, content, after) => `${before}${quoteEnd}a${after}`,
            ),
          }}
        ></a>

        <div style={{ position: "absolute", inset: 0 }}>
          <a
            href={`#${id}`}
            onClick={(e) => handleClickScroll(e, id)}
            style={{
              textDecoration: "none",
              display: "-webkit-box",
              WebkitLineClamp: 1,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              color: "inherit",
              paddingLeft: 0,
              fontWeight: "400",
              fontSize: "12px",
            }}
            dangerouslySetInnerHTML={{ __html: cellInfo.data.Content }}
          ></a>
        </div>
      </div>
    );
  };

  return isLoading ? (
    <Spin />
  ) : (
    <TreeList
      id="content"
      dataSource={contentTitle}
      defaultExpandedRowKeys={[1]}
      showRowLines={viewMode === "edit"}
      showBorders={false}
      columnAutoWidth={true}
      keyExpr="CustomId"
      showColumnHeaders={viewMode === "edit"}
      showColumnLines={viewMode === "edit"}
      autoExpandAll={true}
      parentIdExpr="CustomParentId"
      wordWrapEnabled={true}
    >
      <Scrolling mode="standard" />
      <Column dataField="Title" cellRender={titleRender} allowSorting={false} headerCellRender={() => <p>Mục lục</p>} />
    </TreeList>
  );
};
